import React, {
	useEffect
}from "react"
import {
	Row, Form
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	userActions
}from "../../store/actions/user"
import i18n from "./localization"

import i18nGlobal from "../../localization"
import "./../Appeals/style.css"
import "./style.css"
import {
	CustomInput
}from "../../components/CustomInput"
import CustomButton from "../../components/ButtonCustom"
import FullNameForm from "../UserTypes/fullNameForm"

const CallCenter = (props) => {
	const { reOrg = null, isRegByAdminPage} = props
	const dispatch = useDispatch()
	const [form] = Form.useForm()
	const validateMessages = {
		required: i18n.requiredField[isRu]
	}
	const {
		registerByAdminLoading,
		registerByAdminSuccess,
		roles
	} = useSelector((state) => state.userReducer)
	const isRu = useSelector((state) => state.globalReducer.isRu)

	const onFinish = (values) => {
		values.userType = { name : "callCenter"}
		values.isAdmin = roles?.includes("admin")
		dispatch(userActions.registerByAdmin(values))
	}

	useEffect(() => {
		if (registerByAdminSuccess) form.resetFields([]);
	  }, [registerByAdminSuccess]);

	return (
		<>
			<Row
				align="middle"
				justify="center"
			>
				<Form
					className={`form-register-width${isRegByAdminPage? "" : "2"}`}
					form={ form }
					labelAlign="left"
					labelCol={ { span: 19 } }
					style={ { width: reOrg ? "95%" : null } }
					validateMessages={ validateMessages }
					onFinish={ onFinish }
				>
					<div className={ reOrg ? "" : "block" }>
						<Form.Item
							hasFeedback
							label={ i18nGlobal.userName[isRu] }
							name="userName"
							rules={ [
								{
									pattern  : /^(?=.*[a-zA-Z])[a-zA-Z0-9]+$/,
									message  : i18n.userNameMessage[isRu],
									required : true
								},
								{
									min     : 2,
									max     : 32,
									message : i18n.userNameLength[isRu]
								}
							] }
						>
							<CustomInput
								autoComplete="off"
								maxLength={ 35 }
								placeholder={ i18nGlobal.userName[isRu] }
							/>
						</Form.Item>
						<Form.Item
							hasFeedback
							label="Пароль"
							name="password"
							normalize={ (value) => (value ? value.trim() : value) }
							rules={ [
								{
									required : true,
									pattern  : /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z#$^+=!*()@%&]{8,}$/,
									message  : i18n.passwordMessage[isRu]
								}
							] }
						>
							<CustomInput
								autoComplete="new-password"
								maxLength={ 100 }
								type="password"
							/>
						</Form.Item>

						<Form.Item
							hasFeedback
							dependencies={ ["password"] }
							label={ i18n.confirmPassword[isRu] }
							name="confirm"
							normalize={ (value) => (value ? value.trim() : value) }
							rules={ [
								{
									required : true,
									message  : i18n.confirmPasswordRequired[isRu]
								},
								({ getFieldValue }) => ({
									validator(rule, value){
										if (!value || getFieldValue("password") === value)
											return Promise.resolve()

										return Promise.reject(i18n.passwordEquals[isRu])
									}
								})
							] }
						>
							<CustomInput
								autoComplete="new-password"
								maxLength={ 100 }
								type="password"
							/>
						</Form.Item>
						<FullNameForm
							isNotToChange={false}
							user={null}
							required={true}
							whitespace={false}
						/>
					</div>
					<Form.Item
						className="submit-button-align-right"
					>
						<CustomButton
							htmlType="submit"
							loading={ registerByAdminLoading }
							type="orange"
						>
							{ i18n.register[isRu] }
						</CustomButton>
					</Form.Item>
				</Form>
			</Row>
		</>
	)
}

export default CallCenter
